


























import symbols from './symbols';

export default {
  props: {
    dataset: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    maxSymbolIndex() {
      return this.symbols.length - 1;
    },
    symbols() {
      // flatten data structure into single array
      let values: string[] = [];
      for (const category in this.dataset) {
        values = values.concat(
          ...this
            .dataset[category]
            .map((value: string) => symbols[category][value]),
        );
      }
      return values;
    },
  },
} as IView;
